import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { xlsxExport } from "../../../utils/xlsxExport";
import Table from "../../../components/table/coreUiTable/Table";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";
import { api } from "./api";
import { useTableData } from "../hooks/useTableData";

export const TwoFactorAuthLogsModule = () => {
  let {
    loading,
    tableInfo: { data, colHeaders } = {},
    filteredData,
    onFilteredItemsChange
  } = useTableData({
    endpoint: api.getList
  });

  if (loading) return <LoadingAnimation />;

  return data && data.length > 0 ? (
    <div id="two_factor_auth_logs_table">
      <Table
        table={{ colHeaders, data }}
        title=" "
        showCount={false}
        itemsPerPage={15}
        onFilteredItemsChange={onFilteredItemsChange}
        overTableSlots={
          <div className="content_download">
            {filteredData.length > 0 ? (
              <>
                <a
                  title="Download as Excel"
                  onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      headers: colHeaders,
                      fileName: "2fa-logs",
                      dataStructure: "jts"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </a>
                <a
                  title="Download as CSV"
                  onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      headers: colHeaders,
                      fileName: "2fa-logs",
                      dataStructure: "jts",
                      fileType: "csv"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </a>
              </>
            ) : (
              <>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </span>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </span>
              </>
            )}
          </div>
        }
      />
    </div>
  ) : (
    <NoData />
  );
};
